const KEY = 'hlb.loginReturn';

// Only a page of this app: never another site, whatever ends up in the storage.
const isOwnPage = (path) => typeof path === 'string' && /^\/admin\/[^/\\]/.test(path);

/** Remembers the page a link led to, for after the sign-in it first needs. */
export const rememberLoginReturn = () => {
  try {
    const { pathname, search } = window.location;
    if (isOwnPage(pathname)) sessionStorage.setItem(KEY, `${pathname}${search}`);
  } catch {
    // storage unavailable: the person lands on the home page instead
  }
};

/** The remembered page, or null. Only reading, so a repeated render gets the same answer. */
export const readLoginReturn = () => {
  try {
    const path = sessionStorage.getItem(KEY);
    return isOwnPage(path) ? path : null;
  } catch {
    return null;
  }
};

export const clearLoginReturn = () => {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // storage unavailable: nothing was remembered
  }
};
